import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import Dialog from '../Dialog/Dialog';
import successImg from '../../static/subscribe_succ.png';
import gSuccessImg from '../../static/subscribe_succ_g.png';

import styles from './SubscribeSuccess.module.less';
import { handleSubscribeSucc } from '../../actions/layout';
import { logging } from '../../actions/log';

const selectSubscribeSucc = createSelector(
  state => state.layout,
  layout => layout.subscribeSuccShow,
);

export default memo(() => {
  const dispatch = useDispatch();
  const subscribeSucc = useSelector(selectSubscribeSucc);
  let btnStyle = styles.succ_btn;
  if (subscribeSucc.style) {
    btnStyle = styles.succ_btn_g;
  }

  useEffect(() => {
    return () => {
      dispatch(handleSubscribeSucc({ isShow: false, softId: null, style: null }));
    };
  }, []);

  const handleCancelDialog = () => {
    dispatch(handleSubscribeSucc({ isShow: false, softId: null, style: null }));
  };

  return (
    <>
      <Dialog
        title=""
        maskStyle={styles.mask}
        containerStyle={styles.containerStyle}
        handleClose={handleCancelDialog}
      >
        <img src={subscribeSucc.style ? gSuccessImg : successImg} className={styles.succ_img} />
        <div className={styles.succ_title}>恭喜您，已预约成功！</div>
        <div className={styles.succ_desc}>游戏上架后我们会以消息推送的方式通知您</div>
        <div className={btnStyle} onClick={handleCancelDialog}>
          知道了
        </div>
      </Dialog>
    </>
  );
});
